import { createSlice } from '@reduxjs/toolkit';
import { AssetDataIdentifier } from 'api/services/AssetsService';
import { ToastType } from 'core/constants/enums/ToastTypeEnum.ts';
import { sendToast } from 'core/layouts/components/toast/ToastUtils';
import {
	assetLibraryExtraReducers,
	assetLibraryReducers,
} from 'core/store/reducers/assetsReducer/AssetsActions';
import { assetsInitialState } from 'core/store/reducers/assetsReducer/AssetsInitialState';
import {
	assetsCurrentPageWithTypeSelector,
	assetsHasNextPageWithTypeSelector,
	assetsMapSelector,
	assetsNextTsWithTypeSelector,
} from 'core/store/reducers/assetsReducer/AssetsSelectors';
import { getAssetsAsync } from 'core/store/reducers/assetsReducer/AssetsSliceThunk';

/* eslint-disable no-param-reassign */
export const assetsSlice = createSlice({
	name: 'assets',
	initialState: assetsInitialState,
	reducers: assetLibraryReducers,
	extraReducers: assetLibraryExtraReducers,
});
export const {
	toggleAssetLibraryModal,
	setAssetsWithType,
	appendAssetsWithType,
	addNewAssetWithType,
	updateAssetWithType,
	deleteAssetIdsWithType,
	setAssetsCurrentPage,
	toggleTemplateLibraryModal,
	setIsTemplateAssetSelected,
	setAssetLibraryModalType,
	setUploadedAsset,
	resetAssetState,
} = assetsSlice.actions;

export const changeAssetLibraryCurrentPage = (newPage, type) => async (dispatch, getState) => {
	const state = getState();
	const nextTs = assetsNextTsWithTypeSelector(type)(state);
	const hasNext = assetsHasNextPageWithTypeSelector(type)(state);
	if (hasNext) {
		dispatch(getAssetsAsync({ pageNumber: newPage, nextTs, type }));
	}
};

export const fetchNewAssetLibraryPage = (type) => async (dispatch, getState) => {
	const state = getState();
	const hasNext = assetsHasNextPageWithTypeSelector(type)(state);
	const nextTs = assetsNextTsWithTypeSelector(type)(state);
	const currentPage = assetsCurrentPageWithTypeSelector(type)(state);
	if (hasNext) {
		dispatch(getAssetsAsync({ pageNumber: currentPage + 1, nextTs, type }));
	}
};

export const toggleAssetLibraryModalAction = (modalOpen, modalDetails) => async (dispatch) => {
	dispatch(toggleAssetLibraryModal({ modalOpen, modalDetails }));
};

export const toggleTemplateLibraryModalAction = (modalOpen, modalDetails) => async (dispatch) => {
	dispatch(toggleTemplateLibraryModal({ modalOpen, modalDetails }));
};

export const handleAssetFromPusher = (newAsset) => async (dispatch, getState) => {
	const assetsMap = assetsMapSelector(getState());
	const excludedTags = ['/character/', '/internal/'];
	if (newAsset.status === 'failed') sendToast(ToastType.UPLOAD_ASSET_ERROR);
	if (newAsset.isNsfw) sendToast(ToastType.NSFW_ASSET_IS_NOT_ALLOWED);
	if (!newAsset.id) return;
	// if (assetsCurrentPage === 1) {
	const existingAsset = assetsMap[newAsset.id];
	if (existingAsset != null) {
		if (newAsset.status === 'failed' || newAsset.isNsfw) {
			dispatch(
				deleteAssetIdsWithType({
					assetIds: [newAsset.id],
					type: newAsset.type,
				}),
			);
		} else {
			// const newAssetPendingData = assets[newAssetIndex];
			const updatedAsset = {
				...existingAsset,
				...newAsset,
				name: existingAsset.name,
				[AssetDataIdentifier.META]: {
					...existingAsset[AssetDataIdentifier.META],
					...newAsset[AssetDataIdentifier.META],
				},
			};
			dispatch(
				setUploadedAsset({
					value: updatedAsset,
					type: newAsset.type,
				}),
			);
			dispatch(
				updateAssetWithType({
					value: updatedAsset,
					type: updatedAsset.type,
				}),
			);
		}
	} else if (
		newAsset.status === 'active' &&
		newAsset?.url &&
		!excludedTags.some((tag) => newAsset.url.includes(tag))
	) {
		// Temporary fix for the character image is being added to the asset library
		dispatch(
			addNewAssetWithType({
				value: newAsset,
				type: newAsset.type,
			}),
		);
	}
};

export default assetsSlice.reducer;
